export default "__VITE_ASSET__Dc2d4ahE__"